import React, { forwardRef } from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { END_OF_DAY, START_OF_DAY } from '@vlabs/shared/config';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './DateFilterPopover.module.sass';
import { useListListPageFilters } from '../../useListListPageFilters';

function CreationDateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const { filters, updateFilters } = useListListPageFilters();

  return (
    <PopoverWithButton
      {...props}
      onClickReset={() => updateFilters({
        create_time__gte: undefined,
        create_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__gte"
          label={t('от') ?? ''}
          name="create_time__gte"
          onChange={([create_time__gte]: Date[]) => updateFilters({ create_time__gte })}
          options={START_OF_DAY}
          value={filters.create_time__gte ?? ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__lt"
          label={t('до') ?? ''}
          name="create_time__lt"
          onChange={([create_time__lt]: Date[]) => updateFilters({ create_time__lt })}
          options={END_OF_DAY}
          value={filters.create_time__lt ?? ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const CreationDateFilterPopoverWithRef = forwardRef(CreationDateFilterPopover);
export { CreationDateFilterPopoverWithRef as CreationDateFilterPopover };
